import React from 'react'
import _ from 'lodash'

import {Input} from 'forms'
import {AddressEncoder} from 'ui'
import {parse as decodeAddress} from 'util/address.js'

// validate={value => inRange(group, field, spec.range || [], value)}

export const Address = ({group, field, spec, value, ...props}, {form}) => {
   let patch = _.get(form, `state.patch.${group}.${field}`)

   return (
      <div>
         <Input
            param={group + '.' + field}
            label={spec.label || group + '.' + field}
            groupCssClass="feedback-inline"
            value={patch ? patch : AddressEncoder.encode(value)}
            validate={n => {
               let parsed = decodeAddress(n)

               if (!_.isNumber(parsed) || isNaN(parsed)) {
                  return {error: 'Invalid address'}
               } else if (parsed <= spec.range[0] || parsed >= spec.range[1]) {
                  return {error: 'Field out of range address'}
               } else if (
                  (undefined === spec.multicast || true !== spec.multicast) &&
                  4294967040 <= parsed
               ) {
                  return {error: 'Multicast address'}
               }

               return true
            }}
            feedback={({value: addr, error}) => {
               let parsedValue = decodeAddress(addr || '0')

               return (
                  <span className="help-block">
                     {error
                        ? error
                        : <AddressEncoder pretty={true} value={decodeAddress(parsedValue)} />}
                  </span>
               )
            }}
            disabled={true === spec.ro}
         />
      </div>
   )
}

Address.transform = decodeAddress

Address.contextTypes = {
   form: React.PropTypes.any
}
Address.propTypes = {
   group: React.PropTypes.string.isRequired,
   field: React.PropTypes.string.isRequired,
   spec:  React.PropTypes.object.isRequired,
   value: React.PropTypes.any
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/configuration/fields/Address.jsx